module.exports = __webpack_public_path__ + "static/media/Ayahuasca.f2a3a90f.webp";